import { useEffect, useState } from "react";

const DESKTOP_THRESHOLD = 1000;

export const useWindowResizeListener = () => {
  const [isDesktop, setIsDesktop] = useState<boolean>(window.innerWidth >= DESKTOP_THRESHOLD);

  useEffect(() => {
    const handleResize = () => {
      const computedValue = window.innerWidth >= DESKTOP_THRESHOLD
      if (computedValue != isDesktop) {
        setIsDesktop(computedValue);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [isDesktop]);

  return isDesktop
}